import { useEffect } from 'react';

const ScrollToTop = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 0);
  }, []);

  return null;
};

export default ScrollToTop;
